var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "contact__map" }, [
    !_vm.isMapVisible
      ? _c("div", { staticClass: "contact__map-placeholder" }, [
          _c("div", {
            staticClass: "contact__map-placeholder__image",
            attrs: { "aria-hidden": "true" },
          }),
          _vm._v(" "),
          _c("div", { staticClass: "contact__map-placeholder__content" }, [
            _c("p", { staticClass: "contact__map-placeholder__title" }, [
              _vm._v("\n                Interaktive Karte\n            "),
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "contact__map-placeholder__text" }, [
              _vm._v(
                "\n                Zum Anzeigen der Karte ist Ihre Einwilligung erforderlich.\n                Dabei werden Daten an HERE übermittelt.\n            "
              ),
            ]),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass:
                  "button button--invert contact__map-placeholder__button custom-color-b custom-border-color-b",
                attrs: { type: "button" },
                on: { click: _vm.enableMap },
              },
              [
                _vm._v(
                  "\n                Interaktive Karte anzeigen\n            "
                ),
              ]
            ),
          ]),
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.isMapVisible,
          expression: "isMapVisible",
        },
      ],
      ref: "container",
      staticClass: "contact__map-container",
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }